import React from 'react';
import { Box, NegativeWrapper } from '@landr/maestro';

const Wrapper = ({
    isNegative = false,
    as = 'div',
    children,
}: {
    isNegative?: boolean;
    as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
    children: React.ReactNode;
}): JSX.Element => {
    const component = typeof as !== 'function' ? 'div' : as;

    if (isNegative) {
        return <NegativeWrapper as={component}>{children}</NegativeWrapper>;
    }

    return (
        <Box as={component} position="relative">
            {children}
        </Box>
    );
};

export default Wrapper;
